import React, { useDeferredValue, useState } from 'react';
import { Button } from "react-bootstrap";
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetDocQuery, useRemoveDocMutation } from '../../redux/services/DocService';
import { deleteConfirmation } from "../../utils";
import DocAddModal from './AddModal';
import JobsViewodal from './ViewModal';

const DocumentsPage2 = ({ id }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)
    const [query, setQuery] = useState(null)
    const params = useDeferredValue(query)

    const [removeRequest] = useRemoveDocMutation()
    const [open, setOpen] = useState(false);




    const { data: data2, isFetching } = useGetDocQuery({ id: id ? id : 0, pagination: `?page=${currentPage}&perPage=${perPage}` })
    const drivers = data2?.response?.data?.data
    const total = data2?.response?.data?.total;



    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }


    return (
        <>
            {/* <PageHeader name="Jobs" /> */}


            <div className="main-container container-fluid">

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Create
                                        </Button>

                                    </div>

                                    {/* <div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_').join(' ')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            <div className="card-body">

                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page


                                    columns={[
                                        {
                                            name: 'ID',
                                            selector: row => row.id,
                                            sortable: true,
                                            width: '70px',

                                        },
                                        {
                                            name: 'Doc Name',
                                            selector: row => row.name,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">
                                                        <a
                                                            href={`${row?.file_url}?download`}
                                                            aria-label="view"
                                                            target='_blank'
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-download-2-fill" />
                                                        </a>
                                                        <button
                                                            aria-label="edit"
                                                            // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                                                            onClick={() => handleEdit(row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isShow && (
                <DocAddModal
                    show={isShow}
                    handleClose={() => {
                        setIsShow(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}

            {isView && (
                <JobsViewodal
                    show={isView}
                    handleClose={() => {
                        setIsView(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}

        </>
    );
};

export default DocumentsPage2;